import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, Input, ContentChild, HostBinding, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MODE_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_MODE } from '@taiga-ui/core/tokens';
import * as i1 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import * as i2 from 'rxjs';

class TuiLabelComponent {
    constructor(mode$) {
        this.mode$ = mode$;
        this.context = {
            $implicit: null,
        };
    }
}
TuiLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLabelComponent, deps: [{ token: TUI_MODE }], target: i0.ɵɵFactoryTarget.Component });
TuiLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiLabelComponent, selector: "label[tuiLabel]", inputs: { tuiLabel: "tuiLabel", context: "context" }, host: { listeners: { "$.data-mode.attr": "mode$" }, properties: { "class._control": "this.control" } }, providers: [MODE_PROVIDER], queries: [{ propertyName: "control", first: true, predicate: NgControl, descendants: true }], ngImport: i0, template: "<span class=\"t-label\">\n    <span\n        *polymorpheusOutlet=\"tuiLabel as text; context: context\"\n        class=\"t-text\"\n        [textContent]=\"text\"\n    ></span>\n</span>\n<span class=\"t-content\">\n    <ng-content></ng-content>\n</span>\n", styles: [":host{display:flex;min-height:2.75rem;justify-content:space-between;flex-direction:column;pointer-events:none}.t-label{font:var(--tui-font-text-s);max-width:100%;align-self:inherit;overflow:inherit;pointer-events:auto}:host._control .t-label{margin-bottom:.25rem}.t-text{display:block;overflow:inherit;text-overflow:ellipsis}:host:not(._control) .t-text{color:var(--tui-text-02)}:host([data-mode=\"onDark\"]) .t-text{color:var(--tui-text-02-night)}.t-content{line-height:1.5rem;overflow:inherit;text-overflow:ellipsis;pointer-events:auto}\n"], directives: [{ type: i1.PolymorpheusOutletDirective, selector: "[polymorpheusOutlet]", inputs: ["polymorpheusOutlet", "polymorpheusOutletContext"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLabelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'label[tuiLabel]',
                    templateUrl: './label.template.html',
                    styleUrls: ['./label.style.less'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [MODE_PROVIDER],
                    host: {
                        '($.data-mode.attr)': 'mode$',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i2.Observable, decorators: [{
                    type: Inject,
                    args: [TUI_MODE]
                }] }]; }, propDecorators: { tuiLabel: [{
                type: Input
            }], context: [{
                type: Input
            }], control: [{
                type: ContentChild,
                args: [NgControl]
            }, {
                type: HostBinding,
                args: ['class._control']
            }] } });

class TuiLabelModule {
}
TuiLabelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLabelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiLabelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLabelModule, declarations: [TuiLabelComponent], imports: [PolymorpheusModule], exports: [TuiLabelComponent] });
TuiLabelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLabelModule, imports: [[PolymorpheusModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLabelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [PolymorpheusModule],
                    declarations: [TuiLabelComponent],
                    exports: [TuiLabelComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiLabelComponent, TuiLabelModule };
